export { default as SolidPlantList } from "./List";
